import React, { useState, createContext, useContext } from 'react';
interface ContractorFilterContextType {
  selectedContractors: string[];
  setSelectedContractors: (contractors: string[]) => void;
  isContractorSelected: (contractor: string) => boolean;
  toggleContractor: (contractor: string) => void;
}
const ContractorFilterContext = createContext<ContractorFilterContextType | undefined>(undefined);
export const AVAILABLE_CONTRACTORS = ['Broadway Construction Group', 'AV Mechanic LLC', 'SteelCo Inc', 'Clear Path Contracting LLC', 'Elite Builders Corp'];
export function ContractorFilterProvider({
  children
}: {
  children: ReactNode;
}) {
  const [selectedContractors, setSelectedContractors] = useState<string[]>(AVAILABLE_CONTRACTORS);
  const isContractorSelected = (contractor: string) => {
    return selectedContractors.includes(contractor);
  };
  const toggleContractor = (contractor: string) => {
    setSelectedContractors(prev => {
      if (prev.includes(contractor)) {
        return prev.filter(c => c !== contractor);
      } else {
        return [...prev, contractor];
      }
    });
  };
  return <ContractorFilterContext.Provider value={{
    selectedContractors,
    setSelectedContractors,
    isContractorSelected,
    toggleContractor
  }} data-id="element-4093">
      {children}
    </ContractorFilterContext.Provider>;
}
export function useContractorFilter() {
  const context = useContext(ContractorFilterContext);
  if (context === undefined) {
    throw new Error('useContractorFilter must be used within a ContractorFilterProvider');
  }
  return context;
}